;(() => {
  const swiperUSPS = new Swiper('.swiper-usps', {
    autoplay: false,
    loop: true,
    speed: 500,
    autoHeight: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    breakpoints: {
      800: {
        slidesPerView: 4
      },
      500: {
        slidesPerView: 2,
        slidesPerGroup: 2
      }
    }
  })

  //this seems to help improve LCP score
  document.addEventListener('DOMContentLoaded', function () {
    swiperUSPS.autoplay.start()
  })

  function setSwiperHeight(swiperContainer) {
    const slides = swiperContainer.querySelectorAll('.swiper-slide')
    let tallestHeight = 0

    slides.forEach((slide) => {
      const slideHeight = slide.offsetHeight
      if (slideHeight > tallestHeight) {
        tallestHeight = slideHeight
      }
    })

    swiperContainer.style.height = `${tallestHeight}px`
  }

  new Swiper('.swiper-sub-collections', {
    freeMode: true,
    autoHeight: true,
    slidesPerView: 'auto',
    a11y: {
      slideRole: 'link'
    },
    on: {
      init: function (instance) {
        setSwiperHeight(instance.slidesEl)
      },
      resize: function (instance) {
        setSwiperHeight(instance.slidesEl)
      }
    }
  })

  if (document.querySelector('html').classList.contains('template-product')) {
    const swiperThumbs = new Swiper('.swiper-thumbs', {
      autoHeight: true,
      spaceBetween: 15,
      slidesPerView: 'auto',
      direction: 'vertical'
    })

    const productSlider = new Swiper('.swiper-product', {
      autoHeight: true,
      effect: window.innerWidth >= 800 ? 'fade' : 'slide', //this feature can't be used within breakpoints feature of swiper js
      thumbs: {
        swiper: swiperThumbs
      },
      scrollbar: {
        el: '.swiper-scrollbar.product'
      },
      initialSlide: window.limely.productCarousel.initialSlide,
      slidesPerView: 'auto'
    })

    window.limely = {
      ...window.limely,
      productCarousel: {
        ...window.limely.productCarousel,
        instance: productSlider
      }
    }

    new Swiper('.swiper-more-from-collection', {
      autoHeight: true,
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next.more-from-collection',
        prevEl: '.swiper-button-prev.more-from-collection'
      },
      scrollbar: {
        el: '.swiper-scrollbar.more-from-collection'
      }
    })
  }

  const productfullscreenSlider = new Swiper('.swiper-product-fullscreen', {
    autoHeight: true,
    freeMode: true,
    spaceBetween: 30,
    slidesPerView: 1.1,
    grabCursor: true,
    keyboard: { enabled: true },
    breakpoints: {
      900: {
        slidesPerView: 'auto'
      }
    }
  })

  document
    .querySelectorAll('figure.product-carousel .swiper-product .swiper-slide')
    .forEach((element, index) => {
      element.addEventListener('click', () => {
        productfullscreenSlider.slideTo(index, 0)
        document
          .querySelector('section.product-fullscreen-carousel')
          .classList.add('active')
      })
    })

  document
    .querySelectorAll(
      '#close-product-fullscreen-carousel, #product-fullscreen-carousel-background'
    )
    .forEach((element) => {
      element.addEventListener('click', () => {
        document
          .querySelector('section.product-fullscreen-carousel')
          .classList.remove('active')
      })
    })
})()
